import { Heading, Pane } from 'evergreen-ui';
import { Component } from 'react';
import { connect } from 'react-redux';
import { TabbedView } from '../../common/TabbedView/TabbedView';
import DashboardInstructions from '../components/DashboardInstructions';
import LatestReviews from '../components/LatestReviews';
import OrdersToProcess from '../components/OrdersToProcess';
import PlatformAccess from '../components/PlatformAccess';

class Dashboard extends Component {
    render() {
        const user = this.props.authentication?.user;
        const hasRole = !!user?.role;

        const tabs = [
            {
                title: 'Widgets',
                component: (
                    <Pane display="flex" gap={16} flexWrap="wrap">
                        <Pane flex="2" minWidth="600px">
                            <OrdersToProcess />
                        </Pane>
                        <Pane flex="1" minWidth="400px" maxWidth="500px">
                            <LatestReviews />
                        </Pane>
                    </Pane>
                )
            },
            {
                title: 'Instructions',
                component: <DashboardInstructions />
            },
            ...(hasRole ? [{
                title: 'Platform Access',
                component: <PlatformAccess />
            }] : [])
        ];

        return (
            <>
                <Heading size={600} marginBottom={20}>
                    DASHBOARD
                </Heading>
                <TabbedView tabs={tabs} />
            </>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(mapStateToProps)(Dashboard);
